<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
              <h2 class="form-title text-center">
                Please Complete the Following Two Forms to Process Your Coverage
              </h2>
            </article>
            <article class="d-flex flex-column align-items-center input-section form-section">
              <h5 class="font-weight-bold mb-4">Insurance Company</h5>
              <h5 class="font-weight-bold mb-0">Real Estate Professionals</h5>
              <h5 class="font-weight-bold mb-4">Errors and Omissions Insurance Application</h5>
              <h5 class="font-weight-bold">Reliance on a Competitor’s Application with Statement</h5>
            </article>

            <article class="input-section form-section">
              <div class="pt-0" style="padding-right: 56px;">
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Name:
                    </label>
                    <input
                      type="text"
                      name="firmName"
                      :value="individualAppraiser.fullLegalNameOfAppraiser"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      disabled
                    >
                    <span
                      v-show="errors.has('firmName')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmName') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Address:
                    </label>
                    <input
                      type="text"
                      name="firmAddress"
                      :value="individualAppraiser.customer.address"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      disabled
                    >
                    <span
                      v-show="errors.has('firmAddress')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmAddress') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                      type="text"
                      name="firmCity"
                      v-model="individualAppraiser.customer.city"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      disabled
                    >
                    <span
                      v-show="errors.has('firmCity')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmCity') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <input
                      type="text"
                      name="firmState"
                      :value="states[individualAppraiser.customer.state]"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      disabled
                    >
                    <span
                      v-show="errors.has('firmState')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmState') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      Zip:
                    </label>
                    <input
                      type="text"
                      name="firmZipCode"
                      :value="individualAppraiser.customer.zipCode"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      disabled
                    >
                    <span
                      v-show="errors.has('firmZipCode')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmZipCode') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <h4 class="inputs-table-title">
                Re: Application for Real Estate Professionals Errors & Omissions Insurance
              </h4>
              <div class="pt-0" style="padding-right: 56px;">
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Application:
                    </label>
                    <div class="d-flex flex-column">
                      <input
                        type="text"
                        value="OREP"
                        class="orep-text-input w-100"
                        disabled
                      >
                      <label for class="orep-label mt-2">
                        (Name of Carrier/Professional Liability Program)
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Date Application Signed:
                    </label>
                    <div class="d-flex flex-column">
                      <input
                        type="date"
                        class="orep-text-input w-100 text-center"
                        :value="formattedCurrentDate()"
                        disabled
                      >
                      <label for class="orep-label mt-2">
                        (Month/Day/Year)
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div style="padding-right: 56px;">
                <p class="mb-3">
                  This document acknowledges receipt by Stratford Insurance Company of your firm’s request for a Real Estate Professionals Errors & Omissions Policy.
                </p>
                <p class="mb-3">
                  Your firm’s request for coverage included the application referenced above.
                </p>
                <p class="mb-2">
                  In lieu of requiring your firm to complete our application, we are willing to use the submitted application subject to the following:
                </p>
                <ol type="i" class="mb-3">
                  <li>
                    You agree that we may use the information contained in such application and any attachments to such application in underwriting your account;
                  </li>
                  <li>
                    We may rely upon the truth and accuracy of the representations contained in said application and the attachments to such application;
                  </li>
                  <li>
                    You hereby represent that the statements and information contained in said application and the attachments to such application are true and
accurate to the best of your present knowledge; and
                  </li>
                  <li>
                    Said application, along with this letter, will be deemed attached to and incorporated into any policy we may issue pursuant to it.
                  </li>
                </ol>
                <p class="mb-3">
                  Additionally, you certify that you have no knowledge of any claims, legal, or otherwise, which have been or may be made, against any entity or individual
for which insurance is requested, which has not been reported previously to you or another insurance company. In addition, after making reasonable
inquiries, you are not aware of any act, error or omission, or allegations of any act, error or omissions, or any other circumstances or incidents which could
give rise to a claim as a result of the Company’s operations or any individual’s activities on behalf of the Company.
                </p>
                <p class="mb-3">
                  I, the undersigned, understand that the insurance company’s willingness to provide coverage or reinstate coverage was based on the understanding that
there are no known unreported claims or incidents. I also understand that all such unreported claims or incidents which later result in a claim will not be
covered by the Company’s policy.
                </p>
                <p class="mb-5">
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application.
                  (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
                </p>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Title
                    </label>
                    <input
                      type="text"
                      name="title"
                      v-model="individualAppraiser.title"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('title')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('title') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Signature:
                    </label>
                    <input
                      type="text"
                      name="appSignature"
                      placeholder="Type Your Name to Sign"
                      class="orep-text-input w-100"
                      v-model="individualAppraiser.appSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('appSignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('appSignature') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Date:
                    </label>
                    <input
                      type="date"
                      class="orep-text-input w-100 text-center"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                  </div>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'individual-appraiser-4'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('individual-appraiser-4')"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="next()" :disabled="!state.pageFiveIsValid"></button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageFiveIsValid"
              :class="{submitDisabled: !state.pageFiveIsValid}"
              class="next-btn mont spaced pull-right"
              @click="next()"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import { STATES } from "../../utils/constants";

export default {
  name: "individual-appraiser-5",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    individualAppraiser() {
      return this.$store.state.individualAppraiser.individualAppraiser;
    },
    state() {
      return this.$store.state.individualAppraiser;
    },
    errorMsg() {
      return this.$store.state.individualAppraiser.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    next() {
      this.$router.push({
        name: "individual-appraiser-6"
      });
    },

    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    formattedCurrentDate() {
      return moment(this.individualAppraiser.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFiveIsValid = true;
          return;
        }
        this.state.pageFiveIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>
